import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export default function ProtectedRoute({ children }) {
  const { user } = useAuth();
  if (user === null)
    return (
      <div className="flex h-screen items-center justify-center text-sm text-muted-foreground">
        Yükleniyor...
      </div>
    );
  if (!user) return <Navigate to="/login" replace />;
  return children;
}
